import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { StickyContainer } from 'react-sticky';
import {
    BUCKET_URL_PARAM_TO_AFFCODE_MAPPING,
    SPD_HEADER_DESKTOP,
    SPD_HEADER_MOBILE,
    SPD_HEADER_TITLE,
} from '../constants/seasonal';
import CategoryBrowseDynamicFormatEvents from '../containers/CategoryBrowseDynamicFormatEvents';
import { CategoryBrowseEvents } from '../containers/CategoryBrowseEvents';
import { SeasonalBucketsContainer } from '../containers/SeasonalBucketsContainer';
import { SeasonalCuratedContainer } from '../containers/SeasonalCuratedContainer';
import { SeasonalHeaderContainer } from '../containers/SeasonalHeaderContainer';
import { useEnvContext, useRouteContext, useSearchContext } from '../context';
import {
    CATEGORY_BROWSE_PLACEMENT,
    NIGHTLIFE_CATEGORY_BROWSE_PLACEMENT,
} from '../utils/analytics';
import './SeasonalPage.scss';

export const SeasonalPage: React.FunctionComponent = () => {
    const stPatricksDate = '2024-03-17';
    const defaultBucket = 'bar-crawls';
    const envContext = useEnvContext();
    const locale = envContext?.env?.localeInfo?.locale || 'en_US';
    const { query } = useSearchContext();
    const { parsedValues } = useRouteContext();
    const isWeekendFilter = query?.dates?.includes('this_weekend');
    const customDate = parsedValues?.customDate;
    const routeContext = useRouteContext();
    const date = parsedValues?.date;
    const locationSearch = routeContext.location?.search || '';
    const bucket =
        new URLSearchParams(locationSearch).get('bucket') ?? defaultBucket;

    const affCode = `ebdssqspd${BUCKET_URL_PARAM_TO_AFFCODE_MAPPING[bucket]}`;

    const shouldRenderThisWeekend = () => {
        return date === 'current_future' && !isWeekendFilter && !customDate;
    };

    const renderEventCarousels = () => {
        return (
            <div className="event_carousel">
                <CategoryBrowseEvents
                    queryOverload={{
                        page_size: 8,
                        price: 'paid',
                    }}
                    title={gettext('Most Popular')}
                    bucketName={NIGHTLIFE_CATEGORY_BROWSE_PLACEMENT}
                    bucketKey="most_popular"
                    bucketPosition="1"
                    includeHyperlinks={false}
                    affCode={affCode}
                    renderEmptyState
                />
                <CategoryBrowseEvents
                    queryOverload={{
                        date_range: {
                            to: stPatricksDate,
                            from: stPatricksDate,
                        },
                        page_size: 8,
                        price: 'paid',
                    }}
                    title={gettext("Events on St. Patrick's Day")}
                    bucketName={CATEGORY_BROWSE_PLACEMENT}
                    bucketKey="most_popular"
                    bucketPosition="2"
                    includeHyperlinks={false}
                    affCode={affCode}
                />

                <SeasonalCuratedContainer seasonal="SPD" />

                {shouldRenderThisWeekend() && (
                    <CategoryBrowseEvents
                        queryOverload={{
                            page_size: 8,
                            dates: ['this_weekend'],
                            price: 'paid',
                            aggs: {},
                        }}
                        title={gettext('This weekend')}
                        bucketName={CATEGORY_BROWSE_PLACEMENT}
                        bucketKey="this_weekend"
                        bucketPosition="3"
                        includeHyperlinks={false}
                        affCode={affCode}
                        lazyLoadCarouselElements
                    />
                )}
                {bucket === 'festive-fun' && (
                    <CategoryBrowseDynamicFormatEvents
                        queryOverload={{
                            price: 'paid',
                        }}
                        bucketName={CATEGORY_BROWSE_PLACEMENT}
                        bucketNumber={0}
                        bucketPosition="6"
                        includeHyperlinks={false}
                        affCode={affCode}
                    />
                )}

                <CategoryBrowseEvents
                    queryOverload={{
                        page_size: 8,
                        price: 'free',
                    }}
                    title={gettext('Free')}
                    bucketName={CATEGORY_BROWSE_PLACEMENT}
                    bucketKey="most_popular"
                    bucketPosition="2"
                    includeHyperlinks={false}
                    affCode={affCode}
                />
            </div>
        );
    };

    let isMobile = false;
    if (typeof window !== 'undefined') {
        isMobile = window?.innerWidth <= 480;
    }
    return (
        <>
            <SeasonalHeaderContainer
                title={SPD_HEADER_TITLE}
                locale={locale}
                backgroundImagePath={
                    isMobile ? SPD_HEADER_MOBILE : SPD_HEADER_DESKTOP
                }
            />
            <div className="seasonal__main">
                <StickyContainer style={{ overflowY: 'auto' }}>
                    <SeasonalBucketsContainer />
                    {renderEventCarousels()}
                </StickyContainer>
            </div>
        </>
    );
};
